class CardProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    this.mobileButton = this.parentElement.querySelector('.add-to-car-movil');

    if (this.mobileButton) {
      this.mobileButton.addEventListener('click', this.onMobileButtonClick.bind(this));
    }
  }

  async onMobileButtonClick(evt) {
    evt.preventDefault();
    const button = evt.currentTarget;
    const variantId = button.dataset.variantId;

    if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

    button.setAttribute('aria-disabled', true);
    button.classList.add('loading');

    await this.addToCart(variantId, button);
  }

  async addToCart(variantId, button) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    try {
      const response = await fetch(`${routes.cart_add_url}`, config);
      const parsedState = await response.json();

      if (parsedState.status) {
        this.handleErrorMessage(parsedState.description);
        return;
      }

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      this.cart.renderContents(parsedState);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    }
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    const variantId = this.form.querySelector('[name="id"]').value;
    await this.addToCart(variantId, this.submitButton);
  }

  handleErrorMessage(errorMessage) {
    console.error(errorMessage);
  }
}

customElements.define('product-form', CardProductForm);

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  };
}
